import axios from "axios";

import APIRoutes from "../../APIRoutes";
import { SonicLinkedPages } from "../../../common/classes/SonicLinkedPages";

import { getAPIRoot } from "../../../utils/GeneralUtils";

/**
 * getUserDetail
 *
 * Get information about the user.
 *
 * @param id User id
 * @returns User name and id of data to be linked.
 */

export const getUserDetail = async (
  id: string
): Promise<{
  name: string;
  links: SonicLinkedPages;
}> => {
  const res = await axios.get(getAPIRoot(APIRoutes.get.user_linked), {
    params: {
      id: id,
    },
  });

  return res.data.message;
};
